import React, { useCallback, useEffect, useState } from 'react'
import Layout from '../../layout/Layout'
import { Form, InputGroup, Table, } from 'react-bootstrap'
import CustomPagination from '../../components/CustomPagination';
import DeleteModal from '../../components/DeleteModal';
import NoDateFound from '../../components/NoDateFound';
import Loader from '../../components/loader/Loader';
import ViewPartner from '../../components/partner/ViewPartner';
import { useGlobalState } from '../../context/GlobalStateContext';
import axiosInstance from '../../utils/axiosConfig';
import * as CustomToast from '../../components/CustomToastMessage';
import MyDateRangePicker from '../../components/MyDateRangePicker';

function PartnerList() {

    const [partnerList, setPartnerList] = useState([])

    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    // const [startDate, setStartDate] = useState(new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]);
    // const [endDate, setEndDate] = useState(new Date().toISOString().split('T')[0]);

    const { loading, setLoading, search, pagination, setPagination, handleSearch, handleLimitChange } = useGlobalState()
    const [sortBy, setSortBy] = useState('');

    const fetchPartners = useCallback(async (page = 1, limit = 10, searchQuery = '', from = '', to = '', sort = '') => {
        try {
            setLoading(true);
            const response = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL}/api/admin/partners/list`, {
                params: {
                    page,
                    limit,
                    search: searchQuery,
                    startDate: from,
                    endDate: to,
                    sort: sort

                }
            });
            if (response.data.success) {
                setPartnerList(response.data.data);
                setPagination(response.data.pagination);
            } else {
                setPartnerList([]);
                setPagination(prev => ({
                    ...prev,
                    currentPage: 1,
                    totalPages: 1,
                    totalItems: 0
                }));
            }
        } catch (error) {
            setPartnerList([]);
            setPagination(prev => ({
                ...prev,
                currentPage: 1,
                totalPages: 1,
                totalItems: 0
            }));
            if (error.response.data.status === 400) {
                console.error(error.response?.data?.message);
            }
            console.error(error.response?.data?.message || 'Internal server error');
        } finally {
            setLoading(false);
        }
    }, [setLoading, setPagination])
    useEffect(() => {
        fetchPartners(pagination.currentPage, pagination.limit, search, startDate, endDate, sortBy);
    }, [pagination.currentPage, pagination.limit, search, startDate, endDate, sortBy, fetchPartners]);


    const handleDelete = async (id) => {
        try {
            setLoading(true);

            const response = await axiosInstance.delete(`${process.env.REACT_APP_BACKEND_URL}/api/admin/contact/delete/${id}`);
            if (response.data.success) {
                CustomToast.success(response.data.message);
                fetchPartners(pagination.currentPage, pagination.limit, search, startDate, endDate, sortBy);
            }
        } catch (error) {
            if (error.response.data.status === 400) {
                CustomToast.error(error.response?.data?.message);
            }
            console.error(error.response?.data?.message || 'Internal server error');
        } finally {
            setLoading(false);
        }
    };
    const handleDateRangeChange = (start, end) => {
        setStartDate(start);
        setEndDate(end);
    };
    const handleSortChange = (e) => {
        const value = e.target.value;
        setSortBy(value);
        fetchPartners(1, pagination.limit, search, startDate, endDate, value);
    };
    return (
        <Layout title="Partner List">
            <main>
                <div className="card page-card">
                    <div className="card-header d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
                        <div className='d-flex align-items-center gap-3'>
                            <div className='d-flex align-items-center gap-3'>
                                <p>Show</p>
                                <Form.Select aria-label="Default select example" value={pagination.limit} onChange={handleLimitChange}>

                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                </Form.Select>
                                <p>entries</p>
                            </div>
                            <div className='d-flex align-items-center gap-3 ms-3'>
                                <p>Sort by</p>
                                <Form.Select
                                    aria-label="Sort options"
                                    value={sortBy}
                                    onChange={handleSortChange}
                                    style={{ minWidth: '180px' }}
                                >
                                    <option value="email_asc">Email (A-Z)</option>
                                    <option value="email_desc">Email (Z-A)</option>
                                    <option value="newest">Newest First</option>
                                    <option value="oldest">Oldest First</option>
                                </Form.Select>
                            </div>
                        </div>


                        <div className='d-flex align-items-start align-items-md-center justify-content-end gap-2 flex-column flex-wrap flex-md-row mt-3 mt-xl-0'>
                            <MyDateRangePicker onDateChange={handleDateRangeChange} initialStartDate={startDate} initialEndDate={endDate} />

                            <div className='header-search'>
                                <InputGroup>
                                    <InputGroup.Text id="basic-addon1" className='bg-transparent'>

                                        <img src="/images/png/search.png" width={20} alt="" />
                                    </InputGroup.Text>
                                    <Form.Control
                                        type="search"
                                        className='border-start-0 ps-0'
                                        placeholder="search here..."
                                        value={search}
                                        onChange={handleSearch(fetchPartners)}
                                    />
                                </InputGroup>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="overflow-auto">
                            <Table className='vertical-align'>
                                <thead>
                                    <tr>
                                        <th>Id</th>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Phone</th>
                                        <th>Platform</th>
                                        <th>Message</th>
                                        <th>Enquiry Date</th>
                                        <th width="100" className='text-center'>Action</th>
                                    </tr>
                                </thead>
                                <tbody>{loading ?
                                    (<tr>
                                        <td colSpan="7" className="text-center">
                                            <Loader />
                                        </td>
                                    </tr>) : partnerList.length > 0 ? (
                                        partnerList.map((partner, index) => (
                                            <tr key={partner._id}>
                                                <td width="40">
                                                    <p className='mb-0'>{(pagination.currentPage - 1) * pagination.limit + index + 1}</p>
                                                </td>
                                                <td className='table-td-130'>{partner.name ? partner.name : "-"}</td>
                                                <td>{partner.email ? partner.email : "-"}</td>
                                                <td className='table-td-130'>{partner.phone ? partner.phone : "-"}</td>
                                                <td>{partner.flag === "partner" ? "Mobile" : "Website"}</td>
                                                <td className='table-td-300'>{partner.message ? partner.message : "-"}</td>
                                                <td className='table-td-130'>{partner.createdAt ? new Date(partner.createdAt).toLocaleString() : "-"}</td>
                                                <td>
                                                    <div className='d-flex justify-content-center gap-2'>
                                                        <ViewPartner partner={partner} />
                                                        <DeleteModal
                                                            onConfirm={() => handleDelete(partner._id)}
                                                            loading={loading}
                                                            flag={"partner"}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        ))) : (
                                        <tr>
                                            <td colSpan="10" className="text-center">
                                                <NoDateFound />
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>

                        </div>
                        <CustomPagination
                            currentPage={pagination.currentPage}
                            totalPages={pagination.totalPages}
                            totalItems={pagination.totalPages}
                            limit={pagination.limit}
                            onPageChange={(page) => setPagination(prev => ({ ...prev, currentPage: page }))} />
                    </div>
                </div>
            </main>
        </Layout>
    )
}

export default PartnerList